var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#5364FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.85 19.825C24.8727 19.825 26.5125 18.1852 26.5125 16.1625C26.5125 14.1398 24.8727 12.5 22.85 12.5C20.8272 12.5 19.1875 14.1398 19.1875 16.1625C19.1875 18.1852 20.8272 19.825 22.85 19.825ZM33.85 29.65C33.1125 25.2375 28.875 21.65 24.4 21.65C19.5375 21.65 15.2625 25.5875 14.85 30.4375C14.6875 32.3125 15.2875 34.0875 16.525 35.425C17.75 36.7625 19.475 37.5 21.35 37.5H27.2C29.3125 37.5 31.1625 36.675 32.425 35.1875C33.6875 33.7 34.1875 31.725 33.85 29.65ZM34.225 18.2375C34.225 19.922 32.8595 21.2875 31.175 21.2875C29.4905 21.2875 28.125 19.922 28.125 18.2375C28.125 16.553 29.4905 15.1875 31.175 15.1875C32.8595 15.1875 34.225 16.553 34.225 18.2375ZM35.6875 26.1625C37.0337 26.1625 38.125 25.0712 38.125 23.725C38.125 22.3788 37.0337 21.2875 35.6875 21.2875C34.3413 21.2875 33.25 22.3788 33.25 23.725C33.25 25.0712 34.3413 26.1625 35.6875 26.1625ZM17.975 20.675C17.975 22.3595 16.6095 23.725 14.925 23.725C13.2405 23.725 11.875 22.3595 11.875 20.675C11.875 18.9905 13.2405 17.625 14.925 17.625C16.6095 17.625 17.975 18.9905 17.975 20.675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPets);
export default __webpack_public_path__ + "static/media/icon_pets.d6cf908e570c6c726238b546e8413224.svg";
export { ForwardRef as ReactComponent };